import {Stack, styled} from '@mui/material';

export const StyledStack = styled(Stack)`
	padding: 8px 16px 8px 8px;

	${({theme}) => theme.breakpoints.up('md')} {
		padding: 8px 24px 16px;
	}
`;
